// extracted by mini-css-extract-plugin
export default {"faqHelp":"FaqHelp_faqHelp__ZhU1k","title":"FaqHelp_title__fDGtW","btn":"FaqHelp_btn__ilQ5J"};